export default __webpack_public_path__ + "static/media/slide01.2ecc6b3b.jpg";